import React from 'react'
import TodayDate from './TodayDate'
import Breadcrumb from './Breadcrumb'

const Header = (props) => {
  return (
    <div>
        <h1 className="text-3xl font-semibold">{props.title}</h1>
        <div className="flex items-center justify-between mt-3">
            <Breadcrumb current={props.title} middle={props.middle} />
            <TodayDate />
        </div>
        <div className="w-full my-6 border"></div>
    </div>
  )
}

export default Header